export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-quadtree/index.js
// module id = ../../../../d3-quadtree/index.js
// module chunks = vendor